module.exports = __webpack_public_path__ + "img/商厨类碳标签banner.4990d2ca.png";